import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { VenueModel } from 'src/app/pos-panel/models/venues/venue.model';
import { VenueService } from 'src/app/waiter-panel/services/venues/venue.service';

@Component({
  selector: 'app-venues',
  templateUrl: './venues.component.html',
  styleUrls: ['./venues.component.scss']
})
export class VenuesComponent implements OnInit {
  //#region Fields
  public listAllVenues: Array<VenueModel> = new Array<VenueModel>();
  public unsubscribe: Subject<void> = new Subject<void>();
  public imagePath: string = './assets/images/logo/venuelogo.png'
  public spinner: boolean;
  //#endregion
  //#region Constructor

  constructor(
    public venueService: VenueService,
    private messageService: MessageService,
    public translate: TranslateService,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.getAllVenues();
  }

  //#endregion

  //#region Public Methods
  getAllVenues() {
    this.listAllVenues = new Array<VenueModel>();
    this.spinner = true;
    this.venueService.listvenues()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.listAllVenues = response;
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  navigateToVenue(id: string): void {
    this.router.navigate(['/waiter', id, 'pin']);
  }

  //#endregion
}
